/**
 * Launcher for Desktop/Mobile 3rdParty games
 */

define(function(require, exports, module) {
    'use strict';

    var Base3rdPartyPlatform = require('modules/launcher/platforms/base.3rdParty.platform');
    var _ = require('underscore');
    var url = require('util/url.util');
    var config = require('config');
    var device = require('util/device.util');

    module.exports = _.extend({}, Base3rdPartyPlatform, {

        /**
         * Override
         */
        open: function(game, mode) {
            // singular changes between desktop & mobile platform
            this.provider = game.get(device.isMobilePlatform ? 'mobileGameType' : 'gameType');
            const launchMethod = device.isMobilePlatform
                ? this.getLaunchOptions().launchMethodMobile
                : this.getLaunchOptions().launchMethodDesktop;
            var isRedirectInNewWindow = launchMethod === 'redirectInNewWindow';
            var gameWindow = isRedirectInNewWindow ? url.openNewWindow() : null;

            if (launchMethod === 'wrapperInThisWindow' || launchMethod === 'wrapperInNewWindow') {
                this.launch({
                    provider: this.provider,
                    game: game,
                    mode: mode,
                    gameWindow: gameWindow,
                    urlType: this.getTypeUrl(mode)?.[0]
                });

                return;
            }

            window.Playtech.API.server.getURLTemplate({
                urlTypeList: this.getTypeUrl(mode),
                clientType: config.get('clientType'),
                clientPlatform: device.isMobilePlatform ? 'mobile' : 'web'
            })
                .then((launchUrl) => {
                    this.successLaunch(launchUrl, gameWindow, game, mode);
                })
                .catch(() => {
                    this.failedLaunch(gameWindow, game);
                });
        }
    });
});
